// Vite Entry Point - replaces Shakapacker packs/application.js
console.log("🚀 Vite application.js is loading...");

import "@hotwired/turbo-rails";
import "trix";
import "@rails/actiontext";
import "../controllers"; // Load all Stimulus controllers

console.log("📦 All imports loaded successfully");

// Import React components and initialize them
import React from "react";
import { createRoot } from "react-dom/client";

// Import individual React components
// import ApplicantsSearch from "../components/ApplicantsSearch";
// import DropDown from "../components/DropDown";
import HelloWorld from "../components/HelloWorld";
// import JobInvitation from "../components/JobInvitation";
// import MultiSelect from "../components/MultiSelect";
// import SonnerToastProvider from "../components/SonnerToastProvider";

// Register React components for use in Rails views
const components = {
  // ApplicantsSearch,
  // DropDown,
  HelloWorld,
  // JobInvitation,
  // MultiSelect,
  // SonnerToastProvider,
};

// Auto-mount React components based on data attributes
document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded event fired");
  const reactElements = document.querySelectorAll("[data-react-component]");
  console.log("Found React elements:", reactElements.length);

  reactElements.forEach((element) => {
    // Skip if already mounted
    if (element._reactRoot) {
      console.log(
        `Component already mounted, skipping: ${element.dataset.reactComponent}`
      );
      return;
    }

    const componentName = element.dataset.reactComponent;
    const Component = components[componentName];
    console.log("Mounting component:", componentName, Component);

    if (Component) {
      const props = element.dataset.reactProps
        ? JSON.parse(element.dataset.reactProps)
        : {};
      const root = createRoot(element);
      element._reactRoot = root; // Mark as mounted
      root.render(React.createElement(Component, props));
      console.log("Component mounted successfully:", componentName);
    } else {
      console.error("Component not found:", componentName);
    }
  });
});

// For Turbo compatibility - re-mount components after navigation
document.addEventListener("turbo:load", () => {
  const reactElements = document.querySelectorAll("[data-react-component]");

  reactElements.forEach((element) => {
    if (element._reactRoot) return; // Already mounted

    const componentName = element.dataset.reactComponent;
    const Component = components[componentName];

    if (Component) {
      const props = element.dataset.reactProps
        ? JSON.parse(element.dataset.reactProps)
        : {};
      const root = createRoot(element);
      element._reactRoot = root;
      root.render(React.createElement(Component, props));
    }
  });
});
